const addDaysToDate = (date, numOfDays) => {
    if(date){
        const newDateObject = new Date(date.getTime());
        return new Date(newDateObject.setDate(newDateObject.getDate() + numOfDays));
    }
    else{
        return null;
    }
};

export default addDaysToDate;